import { createMutation, createQuery } from 'react-query-kit';

import * as Types from '../api/purchase/types.api';
import * as API from '../api/purchase/index.api';
import { enqueueSnackbar } from 'notistack';
import { queryClient } from 'src';

//
//

const key = 'purchase';

const invalidateQueryPurchase = (purchaseId: string) => {
  queryClient.invalidateQueries({
    queryKey: usePurchaseByIdGet.getKey({ id: purchaseId }),
  });
};

//

export const usePurchaseByIdGet = createQuery<Types.PurchaseByIdResponse, Types.PurchaseByIdQuery>({
  queryKey: [key],
  fetcher: (params) => API.getPurchaseByIdAPI(params),
});

//

export const usePurchaseBusinessCertificateGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'certificate'],
  mutationFn: (params) => API.getBusinessCertificateAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase certificate successfully downloaded!`, { variant: 'success' });
  },
});

//

export const usePurchaseCustomerCertificateGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'customer-certificate'],
  mutationFn: (params) => API.getCustomerCertificateAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase certificate successfully downloaded!`, {
      variant: 'success',
    });
  },
});

//

export const usePurchaseReceiptGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'receipt'],
  mutationFn: (params) => API.getReceiptAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase receipt successfully downloaded!`, { variant: 'success' });
  },
});

//

export const useMutationLinkBusinessCustomer = createMutation<
  any,
  Types.LinkBusinessCustomerPayload
>({
  mutationKey: [key, 'link-business-customer'],
  mutationFn: (params) => API.linkBusinessCustomerAPI(params),
  onSuccess: (_, variables) => {
    enqueueSnackbar(`Business customer successfully linked`, { variant: 'success' });
    invalidateQueryPurchase(variables.purchaseId);
  },
});
